import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deploymentsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.deployments-menu-item.deployments-item',
		defaultMessage: 'Deployments',
		description: 'Navigation item which links to Deployments page in an classic project',
	},
	deploymentsIconLabel: {
		id: 'spa-apps-sidebar-software-classic.menu.deployments-menu-item.deployments-icon-label',
		defaultMessage: 'View deployment information for issues in this project',
		description:
			'Label for Deployments icon that links to a page to view deployment information issues in the project.',
	},
	deploymentsIconLabelIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.deployments-menu-item.deployments-icon-label-issue-term-refresh',
		defaultMessage: 'View deployment information for work items in this project',
		description:
			'Label for Deployments icon that links to a page to view deployment information issues in the project.',
	},
});
